<template>
  <div class="add-bi-item-container">
    <div
      class="add-bi-item-content"
      @click="$emit('select-chart', item)"
      :class="{ active: isExistInChartSetSelectedList(item), disabled: item.disabled }"
    >
      <div class="add-bi-item-border-content-wrp">
        <div class="add-bi-item-content-header">
          <div class="add-bi-item-content-header-name" :data-fullname="item.chartName">
            {{ item.chartName }}
          </div>
          <div v-bt-tooltips :title="item.tooltip">
            <title-question-icon fill="#93adc1" />
          </div>
        </div>
        <div class="add-bi-item-content-image-graph">
          <img :src="resolveImageGraph" alt="" draggable="false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
//icon
import TitleQuestionIcon from '@/assets/icons/modules/analytics/bi/TitleQuestionIcon.vue';

interface Props {
  item: Bi.BiChartSet.Item;
  chartSetSelectedList: Bi.BiChartSet.Item[];
}

defineEmits(['select-chart']);

const props = defineProps<Props>();

const images = import.meta.glob('/src/assets/images/modules/bi/add-chart-icon/*.png', { eager: true });

const resolveImageGraph = computed(() => {
  const imagePath = `/src/assets/images/modules/bi/add-chart-icon/${props.item.chartImageTypeName}.png`;
  return images[imagePath]?.default || images['/src/assets/images/modules/bi/add-chart-icon/fallback.png'].default;
});

function isExistInChartSetSelectedList(item: Bi.BiChartSet.Item) {
  return props.chartSetSelectedList.find((el) => el === item);
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/modules/analytics/bi/analytics-add-bi-item.scss';
</style>
